// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__vKKnf","alert":"SettungsInbox_alert__27SCo"};